/**
 * Merges paginated edges arrays, deduplicating by node._id.
 *
 * Used in Apollo `fetchMore` `updateQuery` callbacks to prevent
 * duplicate items when re-fetches overlap with pagination cursors.
 */
export function mergeEdges<T extends { node: { _id: string } }>(
  prevEdges: T[],
  newEdges: T[],
): T[] {
  const existingIds = new Set(prevEdges.map((e) => e.node._id));
  const unique = newEdges.filter((e) => !existingIds.has(e.node._id));
  return [...prevEdges, ...unique];
}
